import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { Card, CardContent, Typography, Box, useTheme, useMediaQuery } from '@mui/material';

interface LenderData {
  lender: string;
  count: number;
}

interface TopLendersChartProps {
  data: LenderData[];
  loading?: boolean;
}

const TopLendersChart: React.FC<TopLendersChartProps> = ({ data, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (loading || !data || data.length === 0) {
    return (
      <Card>
        <CardContent>
          <Box sx={{ height: 350, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography color="text.secondary">
              {loading ? 'Loading lender data...' : 'No lender data available'}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  // Take top 10 lenders and reverse for horizontal display
  const topLenders = data.slice(0, 10).reverse();
  
  const lenderNames = topLenders.map(item => {
    // Truncate long lender names on mobile
    if (isMobile && item.lender.length > 20) {
      return item.lender.substring(0, 20) + '...';
    }
    return item.lender;
  });
  
  const claimCounts = topLenders.map(item => item.count);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Top 10 Lenders by Claim Count
        </Typography>
        <Box sx={{ width: '100%', height: 350 }}>
          <BarChart
            layout="horizontal"
            yAxis={[
              {
                data: lenderNames,
                scaleType: 'band',
              },
            ]}
            xAxis={[
              {
                min: 0,
                label: 'Number of Claims',
              },
            ]}
            series={[
              {
                data: claimCounts,
                color: '#007bff',
                valueFormatter: (value) => value ? value.toLocaleString() : '0',
              },
            ]}
            margin={{ 
              left: isMobile ? 100 : 150, 
              right: 40, 
              top: 20, 
              bottom: 50 
            }}
            barLabel="value"
            slotProps={{
              barLabel: {
                style: {
                  fill: 'white',
                  fontWeight: 'bold',
                  fontSize: 12,
                },
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TopLendersChart;